import React from 'react';
import { Container } from '@sm/wds-react';
import { createURL } from '@sm/utils';
import {
  Logo,
  LogoWithText,
  MobileTabletScreen,
  DesktopScreen,
} from '@sm/webassets';

import './simple-logo-header.scss';

const SimpleLogoHeader = () => (
  <Container
    data-testid="SimpleLogoHeader__Container"
    className="sm-simple-logo-header"
  >
    <Container mt={6} flex flexJustify="center">
      <MobileTabletScreen>
        <a
          alt="SurveyMonkey Goldie"
          data-testid="SimpleLogoHeader__Goldie"
          href={createURL('/', {})}
          className="sm-simple-logo-header__goldie"
        >
          <Logo className="sm-simple-logo-header__text" />
        </a>
      </MobileTabletScreen>
    </Container>
    <DesktopScreen>
      <a
        alt="SurveyMonkey Logo"
        data-testid="SimpleLogoHeader__Logo"
        href={createURL('/', {})}
        className="sm-simple-logo-header__logo wds-m-l-7 wds-m-t-7 wds-display--lg-block"
      >
        <LogoWithText className="sm-simple-logo-header__text" />
      </a>
    </DesktopScreen>
  </Container>
);

export default SimpleLogoHeader;
